import {GatewayRegex} from '@models/adminstration/gateway/gateway-configuration/gateway-regex';

export class Alias{
  mask: string = '';
  regexlist: GatewayRegex[] = [];

  constructor(mask: string, regexList: GatewayRegex[]) {
    this.mask = mask;
    this.regexlist = regexList;
  }
}